import { render, staticRenderFns } from "./Payouts.vue?vue&type=template&id=222c3be6&scoped=true&"
import script from "./Payouts.vue?vue&type=script&lang=js&"
export * from "./Payouts.vue?vue&type=script&lang=js&"
import style0 from "./Payouts.vue?vue&type=style&index=0&id=222c3be6&scoped=true&lang=css&"
import style1 from "./Payouts.vue?vue&type=style&index=1&id=222c3be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c3be6",
  null
  
)

export default component.exports